const { pipe, values, pluck, toUpper, toPairs, map, filter } = require("ramda")
const lagos = require("./lagos")
const abuja = require("./abuja")
const ogun = require("./ogun")
const { licenseTypes } = require("./lagos/licenses")

const OGUN_CITY = "ogun"

const citiesData = {
  lagos,
  abuja,
  ogun,
}

const sentenceCase = (n) => `${toUpper(n[0])}${n.slice(1, n.length)}`

const cities = pipe(values, pluck("city"))(citiesData)

const citiesDropDown = pipe(
  toPairs,
  map(([key, { city }]) => ({ value: key, label: sentenceCase(city) }))
)(citiesData)

const citiesWithDeliveryDropDown = pipe(
  toPairs,
  filter(
    ([key, { deliveryPrices }]) => deliveryPrices.length && key !== OGUN_CITY
  ),
  map(([key, { city }]) => ({ value: key, label: sentenceCase(city) }))
)(citiesData)

const allLocationsDeliveryPrices = [
  ...lagos.deliveryPrices,
  ...abuja.deliveryPrices,
]

module.exports = {
  citiesData,
  licenseTypes,
  cities,
  citiesDropDown,
  citiesWithDeliveryDropDown,
  allLocationsDeliveryPrices,
}
